export default __webpack_public_path__ + "static/media/product-get-activity.c971333e.svg";